// project import
import { decodeToken } from 'utils/functions/jwt-token';
import allMenuItems from './menu-items';

// ==============================|| MENU ITEMS ||============================== //
const userData = decodeToken();

const menuItems = {
  items: [allMenuItems]
};

export default menuItems;
